export default __webpack_public_path__ + "static/media/prospect3.02afa3d6.jpg";